export const messages = {
  pl: {
    app: {
      documentTitle: 'Mateusz Słotwiński',
    },
    nav: {
      home: 'Start',
      cv: 'CV',
      projects: 'Projekty',
      blog: 'Blog',
      contact: 'Kontakt',
    },
    home: {
      role: 'Inżynier • Fizyk • Programista',
      blogHeader: 'Sprawdź moje artykuły!',
      keyProjectsHeader:
        'Software? Proszę bardzo! - kilka kluczowych projektów',
      simulationsHeader: 'Zanurkuj w świat fizyki komputerowej!',
      checkoutBlog: 'Sprawdź moje wpisy na blogu!',
    },
    projects: {
      selected: 'Wybrane projekty',
      screenshots: 'SCREENSHOTS',
    },
    cv: {
      achievements: 'Osiągnięcia',
      education: 'Wykształcenie',
      experience: 'Doświadczenie',
      interests: 'Zainteresowania',
      languages: 'Języki',
      projects: 'Projekty',
      science: 'Działalność naukowa',
      skills: 'Umiejętności',
      skillsProgramming: 'PROGRAMISTYCZNE',
      skillsTechnical: 'TECHNICZNE',
      skillsScience: 'NAUKOWE',
      skillsSoft: 'MIĘKKIE',
      certificate: 'Certyfikat',
      bio: 'Student fizyki technicznej i wszechstronny inżynier, łączący dogłębną wiedzę naukową z jej praktycznym zastosowaniem w nowoczesnej technologii. Posiadam szeroką wiedzę i umiejętności z zakresu programowania, informatyki, elektroniki, optoelektroniki oraz technologii półprzewodnikowych, co pozwala mi tworzyć systemy mierzące, analizujące i reagujące na zmiany otoczenia, oraz efektywnie komunikować się z ekspertami z innych dziedzin i integrować ich pracę. Szukam miejsca, w którym mogę wykorzystać swoje interdyscyplinarne kompetencje do tworzenia innowacyjnych rozwiązań dla nauki i technologii.',
      bio2: 'Fizyka techniczna daje mi unikalne spojrzenie na problemy i możliwości ich rozwiązania, a jednocześnie naturalnie łączy wszystkie zagadnienia, którymi się zajmuję — od elektroniki przez symulacje zjawisk fizycznych po półprzewodnikowe i jonowe technologie przyszłości.',
      bio3: 'Na co dzień zajmuje się fizyką zaawansowanych materiałów badając ich właściwości pod kątem zastosowania we współczesnym świecie. Specjalizuję się w jonice, optyce i elektronice ciała stałego, ze szczególnym uwzględnieniem materiałów szklistych, kompozytów szklisto-ceramicznych oraz technologii przetwarzania i magazynowania energii. Do innych moich zainteresowań naukowych należą również elektronika, a także stosowana fizyka jądrowa.',
      courses: 'Kursy',
      publications: 'Publikacje',
      conferences: 'Konferencje',
    },
    details: {
      codeSummary: 'Podsumowanie kodu',
    },
    shared: {
      loading: 'Ładowanie',
      backToCv: 'Wróć do CV',
      hideUnlearned: 'Ukryj nieopanowane',
      clickCheck: 'Kliknij, aby sprawdzić moje {link}!',
      anyPlans: 'Jakieś plany?',
      educationPlans: 'Plany edukacyjne',
      plans: {
        p1: 'Chciałbym studiować na kilku wydziałach, ale nie chodzi tu o pieniądze ani o znalezienie pracy. Po prostu lubię naukę i poznawanie nowych rzeczy. Moim pierwszym i najważniejszym planem jest ukończenie fizyki ze specjalizacją jądrową lub kwantową. Odkrywanie naszego wszechświata i praw nim rządzących jest moją pasją od dzieciństwa. Moimi ulubionymi działami fizyki współczesnej są fizyka kwantowa i jądrowa, ale nie tylko. Uwielbiam również astrofizykę i tematy związane z elektrodynamiką, co prowadzi mnie do kolejnego kierunku, który chcę ukończyć.',
        p2: 'Po fizyce moim kolejnym celem będzie elektronika i informatyka. Programowanie sprawia mi wiele radości, a tematy związane z elektroniką należą do moich ulubionych obszarów badań fizycznych. Obie te dziedziny nauki są ze sobą głęboko powiązane.',
        p3: 'Nie wykluczam, że moje przyszłe zainteresowania mogą pójść w innym kierunku, ale ostatecznie dobrze jest mieć jakiś plan.',
      },
    },
  },

  en: {
    app: {
      documentTitle: 'Mateusz Slotwinski',
    },
    nav: {
      home: 'Home',
      cv: 'CV',
      projects: 'Projects',
      blog: 'Blog',
      contact: 'Contact',
    },
    home: {
      role: 'Engineer • Physicist • Programmer',
      blogHeader: 'Check out my articles!',
      keyProjectsHeader: 'Software? Sure. A few key projects',
      simulationsHeader: 'Dive into the world of computational physics!',
      checkoutBlog: 'Check out my blog posts!',
    },
    projects: {
      selected: 'Selected projects',
      screenshots: 'SCREENSHOTS',
    },
    cv: {
      achievements: 'Achievements',
      education: 'Education',
      experience: 'Experience',
      interests: 'Interests',
      languages: 'Languages',
      projects: 'Projects',
      science: 'Scientific activity',
      skills: 'Skills',
      skillsProgramming: 'PROGRAMMING',
      skillsTechnical: 'TECHNICAL',
      skillsScience: 'SCIENTIFIC',
      skillsSoft: 'SOFT',
      certificate: 'Certificate',
      bio: 'Engineering physics student and interdisciplinary engineer combining deep scientific knowledge with practical implementation in modern technology. I bring broad skills in software development, computer science, electronics, optoelectronics, and semiconductor technologies. This lets me design systems that measure, analyze, and react to environmental changes, while communicating effectively with specialists from other domains and integrating cross-functional work. I am looking for a place where I can use these interdisciplinary competencies to build innovative solutions for science and technology.',
      bio2: 'Engineering physics gives me a unique perspective on problems and the possibilities of solving them, while naturally connecting all the topics I deal with — from electronics through the simulation of physical phenomena to semiconductor and ionic technologies of the future.',
      bio3: 'On a daily basis, I deal with the physics of advanced materials, researching their properties with a view to their application in the modern world. I specialize in ionics, optics, and solid-state electronics, with particular emphasis on glassy materials, glass-ceramic composites, and energy processing and storage technologies. My other scientific interests also include electronics and applied nuclear physics.',
      courses: 'Courses',
      publications: 'Publications',
      conferences: 'Conferences',
    },
    details: {
      codeSummary: 'Code summary',
    },
    shared: {
      loading: 'Loading',
      backToCv: 'Back to my CV',
      hideUnlearned: 'Hide unlearned',
      clickCheck: 'Click here to check my {link}!',
      anyPlans: 'Any plans?',
      educationPlans: 'Education plans',
      plans: {
        p1: 'I would like to study several faculties, but it is not about money or finding a job. I simply enjoy science and learning new things. My first and most important plan is finishing physics with a nuclear or quantum specialization. Discovering our universe and the laws that govern it has been my passion since childhood. My favorite branches are quantum and nuclear physics from modern physics, but not only these. I also love astrophysics and topics related to electrodynamics, which leads to another major I want to complete.',
        p2: 'After physics, my next goal will be electronics and computer science. Programming gives me a lot of joy, and electronics-related topics are among my favorite areas of physics research. Both sciences are deeply connected.',
        p3: 'I do not rule out that my future interests may go in a different direction, but in the end it is good to have a plan.',
      },
    },
  },

  de: {
    app: {
      documentTitle: 'Mateusz Słotwiński',
    },
    nav: {
      home: 'Start',
      cv: 'Lebenslauf',
      projects: 'Projekte',
      blog: 'Blog',
      contact: 'Kontakt',
    },
    home: {
      role: 'Ingenieur • Physiker • Programmierer',
      blogHeader: 'Schau dir meine Artikel an!',
      keyProjectsHeader: 'Software? Na klar! - Ein paar Schlüsselprojekte',
      simulationsHeader: 'Tauche ein in die Welt der Computerphysik!',
      checkoutBlog: 'Schau dir meine Blogbeiträge an!',
    },
    projects: {
      selected: 'Ausgewählte Projekte',
      screenshots: 'SCREENSHOTS',
    },
    cv: {
      achievements: 'Erfolge',
      education: 'Ausbildung',
      experience: 'Berufserfahrung',
      interests: 'Interessen',
      languages: 'Sprachen',
      projects: 'Projekte',
      science: 'Wissenschaftliche Tätigkeit',
      skills: 'Fähigkeiten',
      skillsProgramming: 'PROGRAMMIERUNG',
      skillsTechnical: 'TECHNISCH',
      skillsScience: 'WISSENSCHAFTLICH',
      skillsSoft: 'SOFT SKILLS',
      certificate: 'Zertifikat',
      bio: 'Student der technischen Physik und interdisziplinärer Ingenieur, der fundiertes wissenschaftliches Wissen mit der praktischen Anwendung in moderner Technologie verbindet. Ich verfüge über umfassende Kenntnisse und Fähigkeiten in den Bereichen Programmierung, Informatik, Elektronik, Optoelektronik und Halbleitertechnologien. Dies ermöglicht es mir, Systeme zu entwickeln, die Veränderungen in der Umgebung messen, analysieren und darauf reagieren, sowie effektiv mit Experten aus anderen Bereichen zu kommunizieren und deren Arbeit zu integrieren. Ich suche einen Ort, an dem ich meine interdisziplinären Kompetenzen nutzen kann, um innovative Lösungen für Wissenschaft und Technologie zu schaffen.',
      bio2: 'Die technische Physik gibt mir eine einzigartige Perspektive auf Probleme und deren Lösungsmöglichkeiten und verbindet gleichzeitig auf natürliche Weise alle Themen, mit denen ich mich beschäftige – von der Elektronik über die Simulation physikalischer Phänomene bis hin zu Halbleiter- und Ionen-Technologien der Zukunft.',
      bio3: 'In meiner täglichen Arbeit beschäftige ich mich mit der Physik fortschrittlicher Materialien und untersuche deren Eigenschaften für Anwendungen in der modernen Welt. Ich bin spezialisiert auf Ionik, Optik und Festkörperelektronik, mit besonderem Schwerpunkt auf Glasmaterialien, Glaskeramik-Verbundwerkstoffen sowie Energieumwandlungs- und Speichertechnologien. Zu meinen weiteren wissenschaftlichen Interessen gehören auch Elektronik sowie angewandte Kernphysik.',
      courses: 'Kurse',
      publications: 'Publikationen',
      conferences: 'Konferenzen',
    },
    details: {
      codeSummary: 'Code-Zusammenfassung',
    },
    shared: {
      loading: 'Wird geladen',
      backToCv: 'Zurück zum Lebenslauf',
      hideUnlearned: 'Nicht Gelerntes ausblenden',
      clickCheck: 'Klicke hier, um mein {link} zu sehen!',
      anyPlans: 'Irgendwelche Pläne?',
      educationPlans: 'Bildungspläne',
      plans: {
        p1: 'Ich würde gerne an mehreren Fakultäten studieren, aber es geht nicht um Geld oder darum, einen Job zu finden. Ich genieße einfach die Wissenschaft und das Lernen neuer Dinge. Mein erster und wichtigster Plan ist der Abschluss in Physik mit einer nuklearen oder quantenmechanischen Spezialisierung. Die Entdeckung unseres Universums und der Gesetze, die es regieren, ist seit meiner Kindheit meine Leidenschaft. Meine Lieblingszweige aus der modernen Physik sind die Quanten- und Kernphysik, aber nicht nur diese. Ich liebe auch Astrophysik und Themen im Zusammenhang mit Elektrodynamik, was zu einem weiteren Studiengang führt, den ich abschließen möchte.',
        p2: 'Nach der Physik wird mein nächstes Ziel Elektronik und Informatik sein. Das Programmieren macht mir viel Freude und elektronikbezogene Themen gehören zu meinen bevorzugten Bereichen der physikalischen Forschung. Beide Wissenschaften sind eng miteinander verbunden.',
        p3: 'Ich schließe nicht aus, dass meine zukünftigen Interessen in eine andere Richtung gehen könnten, aber letztendlich ist es gut, einen Plan zu haben.',
      },
    },
  },

  es: {
    app: {
      documentTitle: 'Mateusz Słotwiński',
    },
    nav: {
      home: 'Inicio',
      cv: 'CV',
      projects: 'Proyectos',
      blog: 'Blog',
      contact: 'Contacto',
    },
    home: {
      role: 'Ingeniero • Físico • Programador',
      blogHeader: '¡Mira mis artículos!',
      keyProjectsHeader: '¿Software? ¡Por supuesto! - Algunos proyectos clave',
      simulationsHeader: '¡Sumérgete en el mundo de la física computacional!',
      checkoutBlog: '¡Echa un vistazo a las entradas de mi blog!',
    },
    projects: {
      selected: 'Proyectos seleccionados',
      screenshots: 'CAPTURAS DE PANTALLA',
    },
    cv: {
      achievements: 'Logros',
      education: 'Educación',
      experience: 'Experiencia',
      interests: 'Intereses',
      languages: 'Idiomas',
      projects: 'Proyectos',
      science: 'Actividad científica',
      skills: 'Habilidades',
      skillsProgramming: 'PROGRAMACIÓN',
      skillsTechnical: 'TÉCNICO',
      skillsScience: 'CIENTÍFICO',
      skillsSoft: 'BLANDAS',
      certificate: 'Certificado',
      bio: 'Estudiante de física técnica e ingeniero interdisciplinario, combinando un profundo conocimiento científico con su aplicación práctica en la tecnología moderna. Poseo amplios conocimientos y habilidades en programación, informática, electrónica, optoelectrónica y tecnologías de semiconductores. Esto me permite diseñar sistemas que miden, analizan y reaccionan a los cambios del entorno, así como comunicarme eficazmente con expertos de otras áreas e integrar su trabajo. Busco un lugar donde pueda utilizar mis competencias interdisciplinarias para crear soluciones innovadoras para la ciencia y la tecnología.',
      bio2: 'La física técnica me ofrece una perspectiva única sobre los problemas y las posibilidades de resolverlos, y al mismo tiempo conecta de forma natural todos los temas que trato, desde la electrónica hasta la simulación de fenómenos físicos, pasando por las tecnologías de semiconductores e iones del futuro.',
      bio3: 'En mi día a día me ocupo de la física de materiales avanzados, investigando sus propiedades con vistas a su aplicación en el mundo contemporáneo. Me especializo en iónica, óptica y electrónica de estado sólido, con especial atención a materiales vítreos, compuestos vitrocerámicos y tecnologías de procesamiento y almacenamiento de energía. Entre mis otros intereses científicos también se encuentran la electrónica y la física nuclear aplicada.',
      courses: 'Cursos',
      publications: 'Publicaciones',
      conferences: 'Conferencias',
    },
    details: {
      codeSummary: 'Resumen del código',
    },
    shared: {
      loading: 'Cargando',
      backToCv: 'Volver a mi CV',
      hideUnlearned: 'Ocultar no aprendidos',
      clickCheck: '¡Haz clic aquí para ver mi {link}!',
      anyPlans: '¿Algún plan?',
      educationPlans: 'Planes de educación',
      plans: {
        p1: 'Me gustaría estudiar varias facultades, pero no se trata de dinero ni de encontrar trabajo. Simplemente disfruto de la ciencia y de aprender cosas nuevas. Mi primer y más importante plan es terminar física con una especialización nuclear o cuántica. Descubrir nuestro universo y las leyes que lo gobiernan ha sido mi pasión desde la infancia. Mis ramas favoritas son la física cuántica y nuclear de la física moderna, pero no solo estas. También me encanta la astrofísica y los temas relacionados con la electrodinámica, lo que me lleva a otra carrera que quiero completar.',
        p2: 'Después de la física, mi próximo objetivo será la electrónica y la informática. Programar me da mucha alegría, y los temas relacionados con la electrónica se encuentran entre mis áreas favoritas de investigación física. Ambas ciencias están profundamente conectadas.',
        p3: 'No descarto que mis intereses futuros puedan ir en otra dirección, pero al final es bueno tener un plan.',
      },
    },
  },

  ru: {
    app: {
      documentTitle: 'Матеуш Слотвиньски',
    },
    nav: {
      home: 'Главная',
      cv: 'Резюме',
      projects: 'Проекты',
      blog: 'Блог',
      contact: 'Контакты',
    },
    home: {
      role: 'Инженер • Физик • Программист',
      blogHeader: 'Посмотрите мои статьи!',
      keyProjectsHeader: 'Софт? Без проблем! - Несколько ключевых проектов',
      simulationsHeader: 'Погрузитесь в мир вычислительной физики!',
      checkoutBlog: 'Ознакомьтесь с моими публикациями в блоге!',
    },
    projects: {
      selected: 'Избранные проекты',
      screenshots: 'СКРИНШОТЫ',
    },
    cv: {
      achievements: 'Достижения',
      education: 'Образование',
      experience: 'Опыт работы',
      interests: 'Интересы',
      languages: 'Языки',
      projects: 'Проекты',
      science: 'Научная деятельность',
      skills: 'Навыки',
      skillsProgramming: 'ПРОГРАММИРОВАНИЕ',
      skillsTechnical: 'ТЕХНИЧЕСКИЕ',
      skillsScience: 'НАУЧНЫЕ',
      skillsSoft: 'ГИБКИЕ',
      certificate: 'Сертификат',
      bio: 'Студент технической физики и инженер-универсал, сочетающий глубокие научные знания с их практическим применением в современных технологиях. Обладаю широкими знаниями и навыками в области программирования, информатики, электроники, оптоэлектроники и полупроводниковых технологий. Это позволяет мне создавать системы, которые измеряют, анализируют и реагируют на изменения окружающей среды, а также эффективно общаться с экспертами из других областей и интегрировать их работу. Ищу место, где смогу использовать свои междисциплинарные компетенции для создания инновационных решений для науки и технологий.',
      bio2: 'Техническая физика дает мне уникальный взгляд на проблемы и возможности их решения, и в то же время естественно связывает все темы, которыми я занимаюсь — от электроники и моделирования физических явлений до полупроводниковых и ионных технологий будущего.',
      bio3: 'В повседневной жизни я занимаюсь физикой передовых материалов, исследуя их свойства с точки зрения применения в современном мире. Я специализируюсь на ионике, оптике и физике твердого тела, уделяя особое внимание стеклообразным материалам, стеклокерамическим композитам, а также технологиям преобразования и хранения энергии. В сферу моих научных интересов также входят электроника и прикладная ядерная физика.',
      courses: 'Курсы',
      publications: 'Публикации',
      conferences: 'Конференции',
    },
    details: {
      codeSummary: 'Сводка кода',
    },
    shared: {
      loading: 'Загрузка',
      backToCv: 'Вернуться к резюме',
      hideUnlearned: 'Скрыть неизученное',
      clickCheck: 'Нажмите, чтобы проверить мой {link}!',
      anyPlans: 'Есть ли планы?',
      educationPlans: 'Планы на образование',
      plans: {
        p1: 'Я хотел бы учиться на нескольких факультетах, но дело не в деньгах или поиске работы. Мне просто нравится наука и изучение новых вещей. Мой первый и самый важный план — закончить физику с ядерной или квантовой специализацией. Изучение нашей вселенной и законов, которые ею управляют, было моей страстью с детства. Мои любимые отрасли — квантовая и ядерная физика из современной физики, но не только они. Я также люблю астрофизику и темы, связанные с электродинамикой, что ведет к еще одной специальности, которую я хочу получить.',
        p2: 'После физики моей следующей целью станут электроника и информатика. Программирование приносит мне много радости, а темы, связанные с электроникой, входят в число моих любимых областей физических исследований. Обе науки глубоко связаны.',
        p3: 'Я не исключаю, что мои будущие интересы могут пойти в другом направлении, но в конце концов хорошо иметь план.',
      },
    },
  },

  jp: {
    app: {
      documentTitle: 'Mateusz Słotwiński',
    },
    nav: {
      home: 'ホーム',
      cv: '履歴書',
      projects: 'プロジェクト',
      blog: 'ブログ',
      contact: 'お問い合わせ',
    },
    home: {
      role: 'エンジニア • 物理学者 • プログラマー',
      blogHeader: '記事をチェック！',
      keyProjectsHeader: 'ソフトウェア？もちろん！- いくつかの主要プロジェクト',
      simulationsHeader: '計算物理学の世界へ飛び込もう！',
      checkoutBlog: 'ブログ記事をチェック！',
    },
    projects: {
      selected: '厳選されたプロジェクト',
      screenshots: 'スクリーンショット',
    },
    cv: {
      achievements: '実績',
      education: '学歴',
      experience: '職歴',
      interests: '興味・関心',
      languages: '言語',
      projects: 'プロジェクト',
      science: '科学的活動',
      skills: 'スキル',
      skillsProgramming: 'プログラミング',
      skillsTechnical: '技術',
      skillsScience: '科学',
      skillsSoft: 'ソフトスキル',
      certificate: '証明書',
      bio: '深い科学的知識と最新技術における実践的な実装を組み合わせた、工学物理学を専攻する学際的なエンジニアです。プログラミング、コンピュータサイエンス、電子工学、光電子工学、半導体技術に関する幅広い知識とスキルを持っています。これにより、環境の変化を測定、分析、反応するシステムを設計し、他の分野の専門家と効果的にコミュニケーションを取り、彼らの仕事を統合することができます。科学と技術のための革新的なソリューションを生み出すために、自分の学際的な能力を活かせる場所を探しています。',
      bio2: '技術物理学は、問題とその解決策に対する独自の視点を与えてくれます。同時に、電子工学から物理現象のシミュレーション、未来の半導体やイオン技術に至るまで、私が扱うすべてのトピックを自然に結びつけてくれます。',
      bio3: '日常的には、現代社会への応用を視野に入れ、先端材料の物理学とその特性の研究に取り組んでいます。ガラス材料、ガラスセラミック複合材料、エネルギー変換と貯蔵技術に特に重点を置き、イオニクス、光学、固体電子工学を専門としています。その他の科学的関心事としては、電子工学や応用核物理学なども含まれます。',
      courses: 'コース',
      publications: '出版物',
      conferences: '会議',
    },
    details: {
      codeSummary: 'コードの概要',
    },
    shared: {
      loading: '読み込み中',
      backToCv: '履歴書に戻る',
      hideUnlearned: '未習得を隠す',
      clickCheck: 'ここをクリックして {link} をチェック！',
      anyPlans: '今後の計画は？',
      educationPlans: '教育計画',
      plans: {
        p1: 'いくつかの学部で学びたいと思っていますが、それはお金や仕事のためではありません。ただ科学を楽しみ、新しいことを学ぶのが好きだからです。私の最初の、そして最も重要な計画は、原子核または量子の専門分野で物理学を修了することです。私たちの宇宙とそれを支配する法則を発見することは、子供の頃からの私の情熱でした。現代物理学の中で私の好きな分野は量子物理学と原子核物理学ですが、それだけではありません。天体物理学や電気力学に関連するトピックも大好きで、それが私が修了したい別の専攻につながっています。',
        p2: '物理学の後は、電子工学とコンピュータサイエンスを目標にする予定です。プログラミングは私に多くの喜びをもたらし、電子工学に関連するトピックは物理学の研究の中で私のお気に入りの分野の1つです。両方の科学は深く結びついています。',
        p3: '将来の興味が別の方向に向かう可能性も排除しませんが、最終的には計画を持つことは良いことだと思っています。',
      },
    },
  },
}

export type AppLocale = keyof typeof messages
